import { EditionWithItems } from "@/types/newsletter";
import { Edition } from "@/types/newsletter";

/**
 * Estimate reading time for an edition based on word count.
 * Uses 238 wpm (average adult reading speed).
 * Returns a string like "2 min read".
 */
export function getReadingTime(
  edition: Edition | EditionWithItems,
  items?: { body: string }[]
): string {
  const parts: string[] = [];

  if (edition.hook) parts.push(edition.hook);
  if (edition.custom_message) parts.push(edition.custom_message);
  if (edition.writers_take) parts.push(edition.writers_take);
  if (edition.quote_text) parts.push(edition.quote_text);
  if (edition.quote_attribution) parts.push(edition.quote_attribution);
  if (edition.stat_number) parts.push(edition.stat_number);
  if (edition.stat_caption) parts.push(edition.stat_caption);
  if (edition.one_more_thing) parts.push(edition.one_more_thing);
  if (edition.kicker) parts.push(edition.kicker);

  const editionItems =
    "edition_items" in edition
      ? (edition as EditionWithItems).edition_items
      : items || [];

  for (const item of editionItems) {
    parts.push(item.body);
  }

  const text = parts.join(" ");
  const wordCount = text.split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(wordCount / 238));

  return `${minutes} min read`;
}
